// extracted by mini-css-extract-plugin
export default {"switch":"switch_switch__qsSHH","input":"switch_input__lqJ5R","slider":"switch_slider__Ac6lQ","round":"switch_round__zEqSW"};